import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import "./Footer.css";

const Footer = () => {
  const location = useLocation();
  const [isDarkMode, setIsDarkMode] = useState(false);
  
  // Only apply dark mode logic on optimizer page
  const isOptimizerPage = location.pathname === "/optimizer";

  useEffect(() => {
    if (!isOptimizerPage) return;

    // Function to check if body has the optimizer-dark class
    const checkDarkMode = () => {
      setIsDarkMode(document.body.classList.contains("optimizer-dark"));
    };

    // Check initial state
    checkDarkMode();

    // Create a MutationObserver to watch for class changes on body
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          checkDarkMode();
        }
      });
    });

    // Start observing body for class changes
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['class']
    });

    // Cleanup observer on unmount or when not on optimizer page
    return () => observer.disconnect();
  }, [isOptimizerPage]);

  return (
    <footer className={`footer ${isOptimizerPage ? (isDarkMode ? "dark" : "light") : "light"}`}>
      <ul className="footer-links">
        
        <li><a className="footer-link" href="/faq-support">FAQ</a></li>
  
         <li><a className="footer-link" href="/privacy-page">Privacy Policy</a></li>
         <li><a className="footer-link" href="/terms-of-service">Terms Of Service</a></li> 
          <li><a className="footer-link" href="/contact-support">Contact&Support</a></li>
      </ul>
    </footer>
  );
};

export default Footer;